const INPUT_OPTIONS = {
    brand_id: {
        fieldId: 2364367
    },
    ticket_form_id: {
        fieldId: 360000033656
    },
    orderNumber: {
        fieldId: 360000128175
    },
    preferContactMethod: {
        fieldId: 360000208655
    },
    firstName: {
        fieldId: 80635907
    },
    lastName: {
        fieldId: 80635927
    },
    contactNumber: {
        fieldId: 67323707
    }
};
module.exports = INPUT_OPTIONS;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/misseddelivery/misseddelivery-setup.js
 **/